import React from "react";
import "./Cardc.scss";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMaximize,
  faBed,
  faHouse,
  faShower,
} from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

const Card = ({
  carousel,
  cardID,
  cardtitle,
  title,
  details,
  whatsappLink,
  harga,
}) => {
  const settings = {
    dots: carousel.length > 1,
    arrows: carousel.length > 1,
    infinite: carousel.length > 1,
    slidesToShow: 1,
    slidesToScroll: 1,
    lazyLoad: true,
  };

  return (
    <div id={cardID} className="card">
      <Slider {...settings}>
        {carousel.map((image, index) => (
          <img
            className="imgcarousel"
            key={index}
            src={image}
            alt={`Launching ${index + 1}`}
          />
        ))}
      </Slider>
      <div className="card-content">
        <div className="cardtitle" alt="Myza Logo">
          {cardtitle}
        </div>
        <div className="title">{title}</div>
        <div className="card-icon">
          <hr />
          <FontAwesomeIcon color="#000" icon={faMaximize} />
          <span>&nbsp; : {details.area} &nbsp;</span>
          <FontAwesomeIcon color="#000" icon={faHouse} />
          <span>&nbsp; : {details.buildingSize} &nbsp;</span>
          <FontAwesomeIcon color="#000" icon={faBed} />
          <span>&nbsp; : {details.bedrooms} &nbsp;</span>
          <FontAwesomeIcon color="#000" icon={faShower} />
          <span>&nbsp; : {details.bathrooms} </span>
          <hr />
        </div>
        <div className="cicilan">
          <div className="start">Start From</div>
          <div className="harga">
            {harga} <span>/bln</span>
          </div>
        </div>
        <div className="card-button">
          <button
            className="button"
            onClick={() => window.open(whatsappLink, "_blank")}
          >
            <FontAwesomeIcon icon={faWhatsapp} />
            &nbsp;Whatsapp
          </button>
        </div>
      </div>
    </div>
  );
};

export default Card;
